import { format } from 'date-fns';
import { convertTokens } from '@date-fns/upgrade/v2';
import getLocalDate from '../getLocalDate';
import config from '../../config';

const tideTransform = (tides, legacyUserSettings) => {
  let minMax = [0, 0];
  const associated = tides.associated;
  const lastTide = tides.data.tides.length - 1;
  const data = tides.data.tides
    .map((tide, index) => {
      minMax[0] = tide.height < minMax[0] || minMax[0] === 0 ? tide.height : minMax[0];
      minMax[1] = tide.height > minMax[1] ? tide.height : minMax[1];
      const offset = associated.timezone.filter(zone =>
        zone.id === tide.timezone.id)[0].offset;
      const localDate = getLocalDate(tide.timestamp, offset);
      return {
        id: index,
        value: tide.height,
        type: tide.analysis,
        timestamp: localDate,
        monthDay: format(localDate, convertTokens('M/D')),
        formattedTime: format(localDate, convertTokens('h:mmA')),
        localTimeString: format(localDate, convertTokens('MMMM DD, YYYY HH:MM:SS')),
      };
    })
    .filter((tide, index) => !(tide.type === 'NORMAL' && index !== 0 && index !== lastTide));

  // add 1m buffer to allow space for high and low tide labels
  minMax[0] -= 1;
  minMax[1] += 1;

  const [min, max] = minMax;
  let tideScale = [];
  switch (true) {
    case (max <= 4 && min >= -4 && associated.units.tide === 'm'):
      minMax = [-4, 4];
      tideScale = config.pages.forecast.marine_weather.tideScale.four;
      break;
    case (max <= 6 && min >= -6):
      minMax = [-6, 6];
      tideScale = config.pages.forecast.marine_weather.tideScale.six;
      break;
    case (max <= 8 && min >= -8):
      minMax = [-8, 8];
      tideScale = config.pages.forecast.marine_weather.tideScale.eight;
      break;
    case (max <= 12 && min >= -12):
      minMax = [-12, 12];
      tideScale = config.pages.forecast.marine_weather.tideScale.twelve;
      break;
    case (max <= 16 && min >= -16):
      minMax = [-16, 16];
      tideScale = config.pages.forecast.marine_weather.tideScale.sixteen;
      break;
    case (max <= 20 && min >= -20):
      minMax = [-20, 20];
      tideScale = config.pages.forecast.marine_weather.tideScale.twenty;
      break;
    default:
      minMax = [-32, 32];
      tideScale = config.pages.forecast.marine_weather.tideScale.thirtytwo;
      break;
  }
  return {
    tides: {
      data,
      minMax,
      tideScale,
      units: associated.units.tide,
      tz: associated.timezone[0].offset,
      numberOfFreeDays: 2,
      userType: legacyUserSettings.type,
    },
  };
};

export default tideTransform;



// WEBPACK FOOTER //
// ./src/utils/tides/tidesTransform.js